import { useLayoutEffect, useRef } from 'react'

export const useAdaptiveStickyColomn = ({
  indent,
  minHeight = 200,
}: {
  indent: number
  minHeight?: number
}) => {
  const adaptiveElementRef = useRef<HTMLDivElement>(null)

  useLayoutEffect(() => {
    const resizeFilter = () => {
      if (adaptiveElementRef.current) {
        const clientRect = adaptiveElementRef.current.getBoundingClientRect()
        const windowInnerHeight = window.innerHeight

        adaptiveElementRef.current.style.height =
          Math.max(windowInnerHeight - clientRect.top - indent, minHeight) + 'px'
      }
    }
    resizeFilter()
    window.addEventListener('scroll', resizeFilter)
    window.addEventListener('resize', resizeFilter)
    return () => {
      window.removeEventListener('scroll', resizeFilter)
      window.removeEventListener('resize', resizeFilter)
    }
  }, [indent, minHeight])

  return {
    adaptiveElementRef,
  }
}
